// covered-by: frontends/carrie/src/components/ask-puntt-review/__tests__/AskPunttReviewCommentBadge.test.tsx
type AskPunttReviewCommentBadgeProps = {
  number: number;
  className?: string;
  "data-testid"?: string;
};

export function AskPunttReviewCommentBadge({
  number,
  className = "",
  "data-testid": testId,
}: AskPunttReviewCommentBadgeProps) {
  return (
    <span
      className={`flex size-7 shrink-0 items-center justify-center rounded-full bg-puntt-accent-9 text-[12px] font-semibold text-base-white ${className}`}
      data-testid={testId}
      aria-hidden="true"
    >
      {number}
    </span>
  );
}
